(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.newsletter-reviews').forEach(function (section) {
      if (section.dataset.testimonialCarouselReady === 'true') return;

      section.dataset.testimonialCarouselReady = 'true';

      var carousel = section.querySelector('[data-testimonial-carousel]');
      var track = section.querySelector('[data-testimonial-track]');
      var prevBtn = section.querySelector('[data-testimonial-prev]');
      var nextBtn = section.querySelector('[data-testimonial-next]');
      var dotsContainer = section.querySelector('[data-testimonial-dots]');

      if (!carousel || !track || !prevBtn || !nextBtn || !dotsContainer) return;

      var cards = track.querySelectorAll('.nr__testimonial-card');
      if (cards.length === 0) return;

      var currentIndex = 0;
      var dragState = null;
      var suppressClick = false;

      function getCardsPerView() {
        return window.innerWidth > 1280 ? 2 : 1;
      }

      function getGap() {
        var styles = window.getComputedStyle(track);

        return parseFloat(styles.columnGap || styles.gap || '30') || 30;
      }

      function getMaxIndex() {
        return Math.max(0, Math.ceil(cards.length / getCardsPerView()) - 1);
      }

      function clampIndex(index) {
        return Math.max(0, Math.min(index, getMaxIndex()));
      }

      function getMetrics() {
        var cardsPerView = getCardsPerView();
        var gap = getGap();
        var containerWidth = carousel.offsetWidth;
        var cardWidth = (containerWidth - gap * (cardsPerView - 1)) / cardsPerView;
        var pageWidth = (cardWidth + gap) * cardsPerView;
        var maxIndex = getMaxIndex();

        return {
          pageWidth: pageWidth,
          maxIndex: maxIndex,
          maxOffset: maxIndex * pageWidth,
          containerWidth: containerWidth,
        };
      }

      function getOffsetForIndex(index) {
        return clampIndex(index) * getMetrics().pageWidth;
      }

      function setTrackOffset(offset) {
        track.style.transform = 'translateX(' + -offset + 'px)';
      }

      function updateNavButtons() {
        prevBtn.disabled = currentIndex <= 0;
        nextBtn.disabled = currentIndex >= getMaxIndex();
      }

      function buildDots() {
        dotsContainer.innerHTML = '';
        var totalPages = getMaxIndex() + 1;
        for (var i = 0; i < totalPages; i++) {
          var dot = document.createElement('button');
          dot.className = 'nr__dot' + (i === currentIndex ? ' nr__dot--active' : '');
          dot.setAttribute('data-testimonial-dot', i);
          dot.type = 'button';
          dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          dot.addEventListener('click', function () {
            currentIndex = clampIndex(parseInt(this.getAttribute('data-testimonial-dot'), 10));
            updateCarousel();
          });
          dotsContainer.appendChild(dot);
        }
      }

      function updateCarousel() {
        currentIndex = clampIndex(currentIndex);
        setTrackOffset(getOffsetForIndex(currentIndex));

        var dots = dotsContainer.querySelectorAll('[data-testimonial-dot]');
        dots.forEach(function (dot, i) {
          if (i === currentIndex) {
            dot.classList.add('nr__dot--active');
          } else {
            dot.classList.remove('nr__dot--active');
          }
        });

        carousel.classList.toggle('is-draggable', getMaxIndex() > 0);
        updateNavButtons();
      }

      function setDraggingState(isDragging) {
        carousel.classList.toggle('is-dragging', isDragging);
        track.classList.toggle('is-dragging', isDragging);
      }

      function clearSuppressClick() {
        window.setTimeout(function () {
          suppressClick = false;
        }, 0);
      }

      function startDrag(event) {
        if (getMaxIndex() === 0 || dragState) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (event.isPrimary === false) return;

        dragState = {
          pointerId: event.pointerId,
          startX: event.clientX,
          deltaX: 0,
          metrics: getMetrics(),
          baseOffset: getOffsetForIndex(currentIndex),
        };

        if (carousel.setPointerCapture) {
          carousel.setPointerCapture(event.pointerId);
        }

        setDraggingState(true);
      }

      function moveDrag(event) {
        if (!dragState || event.pointerId !== dragState.pointerId) return;

        dragState.deltaX = event.clientX - dragState.startX;

        if (Math.abs(dragState.deltaX) > 6) {
          suppressClick = true;
          event.preventDefault();
        }

        var rawOffset = dragState.baseOffset - dragState.deltaX;
        var boundedOffset = rawOffset;

        if (boundedOffset < 0) {
          boundedOffset = rawOffset / 3;
        } else if (boundedOffset > dragState.metrics.maxOffset) {
          boundedOffset = dragState.metrics.maxOffset + (rawOffset - dragState.metrics.maxOffset) / 3;
        }

        setTrackOffset(boundedOffset);
      }

      function endDrag(event) {
        if (!dragState) return;
        if (event && event.pointerId !== dragState.pointerId) return;

        if (carousel.releasePointerCapture) {
          try {
            carousel.releasePointerCapture(dragState.pointerId);
          } catch (error) {
          }
        }

        var deltaX = dragState.deltaX;
        var threshold = Math.max(40, Math.min(dragState.metrics.containerWidth * 0.15, 120));
        var rawOffset = dragState.baseOffset - deltaX;
        var boundedOffset = Math.max(0, Math.min(rawOffset, dragState.metrics.maxOffset));
        var targetIndex = clampIndex(Math.round(boundedOffset / dragState.metrics.pageWidth));

        setDraggingState(false);

        if (Math.abs(deltaX) > threshold) {
          currentIndex = targetIndex;

          if (currentIndex === clampIndex(Math.round(dragState.baseOffset / dragState.metrics.pageWidth))) {
            currentIndex = clampIndex(currentIndex + (deltaX < 0 ? 1 : -1));
          }
        }

        updateCarousel();
        dragState = null;

        if (suppressClick) {
          clearSuppressClick();
        }
      }

      prevBtn.addEventListener('click', function () {
        if (currentIndex > 0) {
          currentIndex--;
          updateCarousel();
        }
      });

      nextBtn.addEventListener('click', function () {
        if (currentIndex < getMaxIndex()) {
          currentIndex++;
          updateCarousel();
        }
      });

      carousel.addEventListener('pointerdown', startDrag);
      carousel.addEventListener('pointermove', moveDrag);
      carousel.addEventListener('pointerup', endDrag);
      carousel.addEventListener('pointercancel', endDrag);
      carousel.addEventListener(
        'click',
        function (event) {
          if (!suppressClick) return;

          event.preventDefault();
          event.stopPropagation();
        },
        true
      );
      carousel.addEventListener('dragstart', function (event) {
        event.preventDefault();
      });

      buildDots();
      updateCarousel();

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          dragState = null;
          setDraggingState(false);
          if (currentIndex > getMaxIndex()) {
            currentIndex = getMaxIndex();
          }
          buildDots();
          updateCarousel();
        }, 150);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
